import React, { Component } from 'react';
import { Configurations } from '../../Utils/Configurations';
import Usuario from '../../Utils/Usuario';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import { Permissions } from '../../Utils/Permissions';
import { AsyncTypeahead, Highlighter } from 'react-bootstrap-typeahead';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import InputMask from 'react-input-mask';
import UserPhoto from '../../Components/UserPhoto/UserPhoto';
import axios from 'axios';
import update from 'immutability-helper';
import 'moment/locale/pt-br';
import './Assistance.scss';
import HistoricoAtendimento from '../../Components/Assistance/Assistance-History';
import CardOcorrencia from '../../Components/Assistance/Occurrence/Card-Occurrence';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import ModalAlteracoes from '../../Components/Modal-Alteracoes/Modal-Alteracoes';
import { Prompt } from 'react-router-dom';
import { Consumer } from '../../Context/Context-Menu-Acesso-Rapido/Context-Menu-Acesso-Rapido';
class NovoAtendimento extends Component {

    constructor() {
        super();

        this.handleRadio = this.handleRadio.bind(this);
        this.carregaCategorias = this.carregaCategorias.bind(this);
        this.carregaInfosSolicitante = this.carregaInfosSolicitante.bind(this);
        this.carregaInfosAtendimento = this.carregaInfosAtendimento.bind(this);
        this.carregaHistoricoAtendimento = this.carregaHistoricoAtendimento.bind(this);
        this.carregaOcorrenciasAtendimento = this.carregaOcorrenciasAtendimento.bind(this);
        this.criaAtendimento = this.criaAtendimento.bind(this);
        this.toggleCadastroSolicitante = this.toggleCadastroSolicitante.bind(this);
        this.tipoBadgeAtendimento = this.tipoBadgeAtendimento.bind(this);
        this.tipoBadgePrioridade = this.tipoBadgePrioridade.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnChangeTelefones = this.handleOnChangeTelefones.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.atualizaAtendimento = this.atualizaAtendimento.bind(this);
        this.finalizarAtendimento = this.finalizarAtendimento.bind(this);
        this.removerTelefone = this.removerTelefone.bind(this);
        this.novoTelefone = this.novoTelefone.bind(this);
        this.toggleModalTelefone = this.toggleModalTelefone.bind(this);
        this.atualizarDadosCadastrais = this.atualizarDadosCadastrais.bind(this);
        this.maskPhone = this.maskPhone.bind(this);
        this.salvarOcorrencia = this.salvarOcorrencia.bind(this);
        this.excluirOcorrencia = this.excluirOcorrencia.bind(this);
        this.novaOcorrencia = this.novaOcorrencia.bind(this);
        this.setInitialState = this.setInitialState.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.toggleModalAlteracoes = this.toggleModalAlteracoes.bind(this);
        this.handleBlockedNavigation = this.handleBlockedNavigation.bind(this);
        this.handleConfirmNavigationClick = this.handleConfirmNavigationClick.bind(this);
        this.showModalAlteracoes = this.showModalAlteracoes.bind(this);
        this.closeModalAlteracoes = this.closeModalAlteracoes.bind(this);
        this.verificaPendencias = this.verificaPendencias.bind(this);
        this.alteracoesNaoSalvas = this.alteracoesNaoSalvas.bind(this);
        this.registraPendenciaOcorrencia = this.registraPendenciaOcorrencia.bind(this);
        this.toggleModalAvisoOcorrencia = this.toggleModalAvisoOcorrencia.bind(this);
        this.atualizaContextAtendimentos = this.atualizaContextAtendimentos.bind(this);

        this.initialState = {
            isLoading: false,
            isLoadingSolicitante: true,
            isLoadingAtendimento: true,
            isLoadingHistorico: true,
            isLoadingOcorrencias: true,
            options: [],
            flagBuscaSolicitante: false,
            exibeCadastroSolicitante: false,
            solicitanteCadastrado: false,
            atendimentoCriado: false,
            descricaoAtendimento: '',
            atendimentoSemSolicitante: false,
            modalRemoverTelefone: false,
            telefonesSolicitante: [],
            listaOcorrencias: [],
            infosAtendimento: [],
            infosSolicitante: [],
            emailSolicitante: '',
            isLoadingGeral: 0,
            isLoadingAtualizacaoCadastral: 0,
            jaCarregouInfosSolicitante: false,
            jaCarregouOcorrencias: false,
            hasError: false,
            errorMessage: '',
            pedidoFinalizado: false,
            modalAlteracoes: false,
            shouldBlockNavigation: false,
            // shouldBlockNavigation: true,
            lastLocation: null,
            confirmedNavigation: false,
            mensagemPendencias: [],
            algumaPendenciaOcorrencia: false,
            modalAvisoOcorrencia: false,
            mudancaStatusAtendimento: false,
        };

        this.state = this.initialState;

        this.prioridadesOptions = [
            { label: "Baixa", value: 1 },
            { label: "Média", value: 2 },
            { label: "Alta", value: 3 },
        ];

        this.paisesOptions = [
            { label: "Brasil", value: "55" },
            { label: "Japão", value: "81" },
            { label: "EUA", value: "1" },
        ];

        this.tipoTelefoneOptions = [
            { label: "Residencial", value: 1 },
            { label: "Celular", value: 2 },
            { label: "Comercial", value: 3 },
        ];

        this.configurations = new Configurations();

        this.ultimosDadosAtendimento = {
            descricao: undefined,
            campo: "Descrição do Atendimento"
        };
        this.ultimosDadosCadastrais = {
            email: undefined,
            telefones: [],
            campo: "Dados Cadastrais"
        };
        this.ultimosDadosOcorrencias = {
            ocorrencias: [],
            campo: "Ocorrência",
            idOcorrencia: null,
        };

        this.pendencias = {
            descricaoAtendimento: { pendente: false, mensagem: "Descrição do Atendimento" },
            emailSolicitante: { pendente: false, mensagem: "Dados Cadastrais" },
            telefonesSolicitante: { pendente: false, mensagem: "Dados Cadastrais" },
            ocorrencias: { pendente: false, mensagem: "Ocorrências" }
        };
    }

    setInitialState() {
        this.setState(this.initialState)
        this.setState({ novoAtendimento: true, shouldBlockNavigation: false, atendimentoCriado: false, isLoading: false })
    }

    componentDidUpdate(prevProps) {
        const prevIdAtendimento = prevProps.match.params.idAtendimento;
        const novoIdAtendimento = this.props.match.params.idAtendimento;
        if ((prevIdAtendimento !== novoIdAtendimento) && novoIdAtendimento === 'novo-atendimento') {
            this.setInitialState();
        }
        else if ((prevIdAtendimento !== novoIdAtendimento) && parseInt(novoIdAtendimento, 10)) {
            this.setState({
                // shouldBlockNavigation: true,
            }, () => {
                this.setState(this.initialState, () => {
                    this.ultimosDadosAtendimento = {
                        descricao: undefined,
                        campo: "Descrição do Atendimento"
                    };
                    this.ultimosDadosCadastrais = {
                        email: undefined,
                        telefones: [],
                        campo: "Dados Cadastrais"
                    };
                    this.ultimosDadosOcorrencias = {
                        ocorrencias: [],
                        campo: "Ocorrência",
                        idOcorrencia: null,
                    };
                    this.carregaInfosAtendimento(novoIdAtendimento);
                    this.setState({
                        atendimentoCriado: true,
                        novoAtendimento: false,
                    }, () => {
                        this.pendencias = {
                            descricaoAtendimento: { pendente: false, mensagem: "Descrição do Atendimento" },
                            emailSolicitante: { pendente: false, mensagem: "Dados Cadastrais" },
                            telefonesSolicitante: { pendente: false, mensagem: "Dados Cadastrais" },
                            ocorrencias: { pendente: false, mensagem: "Ocorrências" }
                        };
                    })
                })
            })
        }

        // if (prevIdAtendimento === 'novo-atendimento' && Number.isInteger(Number(novoIdAtendimento))) {
        //     this.setState({ shouldBlockNavigation: false });
        // } else if ((prevIdAtendimento !== novoIdAtendimento) || (prevPathname !== novoPathname)) this.setState({ shouldBlockNavigation: true })

        // if (shouldBlockNavigation) {
        //     window.onbeforeunload = () => true
        // } else {
        //     window.onbeforeunload = undefined
        // }
    }

    componentWillMount() {
        const _paramAtendimento = this.props.match.params.idAtendimento;
        if (_paramAtendimento === 'novo-atendimento') {
            this.setState({
                novoAtendimento: true,
                atendimentoCriado: false,
                // shouldBlockNavigation: false,
            }, () => this.setState({ isLoading: false }))
        } else if (parseInt(_paramAtendimento, 10)) {
            this.setState({
                atendimentoCriado: true,
                novoAtendimento: false,
                // shouldBlockNavigation: true,
            }, () => {
                this.carregaInfosAtendimento(_paramAtendimento)
            })
        } else this.props.history.push('/atendimentos/lista')

    }

    componentDidMount() {
        const _arrPerm = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const _paginas = _arrPerm.map(item => Permissions.pagesAccess(item)).flat();
        let _busca;
        if (["admin"].some(r => _paginas.indexOf(r) >= 0)) {
            _busca = true;
        } else {
            _busca = ["atendimento"].some(r => _paginas.indexOf(r) >= 0);
        }
        this.setState({ buscaHeader: _busca })
        this.carregaCategorias();
    }

    handleRadio(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    tipoBadgeAtendimento(status) {
        switch (status) {
            case 2:
                return "warning";
            case 3:
                return "info";
            case 4:
                return "success";
            default: //
                return "primary";
        }
    }

    tipoBadgePrioridade(status) {
        switch (status) {
            case 1:
                return "secondary";
            case 2:
                return "warning";
            default: // 3
                return "danger";
        }
    }

    carregaCategorias() {
        this.setState({ loading: true })
        axios.get(this.configurations.apiBasePath + `/atendimentos/categorias`).then(response => {
            let _arrayFinalCategorias = [];
            response.data.listaCategorias.forEach(item => {
                if (item.subCategorias && item.subCategorias.length > 0) {
                    _arrayFinalCategorias.push(
                        {
                            label: item.nome, value: item.idCategoria, pai: true,
                        });
                    _arrayFinalCategorias.push(
                        {
                            label: `Subcategorias de ${item.nome}`,
                            options: item.subCategorias.map(sub => ({ label: `${sub.nomeCategoria}`, value: sub.idCategoria }))
                        });
                }
            })
            this.setState({ categoriasOptions: _arrayFinalCategorias })
        }).catch(this.handleError).finally(() => this.setState({ loading: false }));
    }

    carregaInfosSolicitante(_codMembro) {
        this.setState({ isLoadingSolicitante: true, flagBuscaSolicitante: true })
        axios.get(this.configurations.apiBasePath + `/membros/detalhes/${_codMembro}`).then(response => {
            this.ultimosDadosCadastrais.email = response.data.data.email;
            this.ultimosDadosCadastrais.telefones = response.data.data.telefones;
            this.setState({
                infosSolicitante: response.data.data,
                emailSolicitante: response.data.data.email,
                telefonesSolicitante: response.data.data.telefones,
                jaCarregouInfosSolicitante: true
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingSolicitante: false, isLoadingAtendimento: false }));
    }

    carregaInfosAtendimento(_idAtend, flagOcorrencias = null) {
        this.setState({ isLoadingAtendimento: true, isLoadingGeral: this.state.isLoadingGeral + 1 })
        axios.get(this.configurations.apiBasePath + `/atendimentos/${_idAtend}`).then(response => {
            this.ultimosDadosAtendimento.descricao = response.data.descricao;
            this.setState({
                infosAtendimento: response.data,
                atendimentoSemSolicitante: !response.data.idSolicitante,
                descricaoAtendimento: this.state.descricaoAtendimento !== '' ? this.state.descricaoAtendimento : (response.data.descricao ? response.data.descricao : null),
                pedidoFinalizado: response.data.idStatusAtendimento === 4,
                shouldBlockNavigation: response.data.idStatusAtendimento === 4 ? false : this.state.shouldBlockNavigation
            },
                () => {
                    this.carregaHistoricoAtendimento(_idAtend);
                    if (!flagOcorrencias) this.carregaOcorrenciasAtendimento(_idAtend);

                    if (!this.state.atendimentoSemSolicitante && !this.state.jaCarregouInfosSolicitante) {
                        this.carregaInfosSolicitante(this.state.infosAtendimento.codMembro)
                    } else if (this.state.atendimentoSemSolicitante) this.setState({ isLoadingSolicitante: false })
                }
            );
        }).catch(this.handleError).finally(() => this.setState({ isLoadingAtendimento: false, isLoadingGeral: this.state.isLoadingGeral - 1 }));
    }

    carregaHistoricoAtendimento(_idAtend) {
        axios.get(this.configurations.apiBasePath + `/atendimentos/${_idAtend}/historicos`).then(response => {
            this.setState({
                historicoAtendimento: response.data.historico
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingHistorico: false }));
    }

    carregaOcorrenciasAtendimento(_idAtend, flag = null) {
        axios.get(this.configurations.apiBasePath + `/atendimentos/${_idAtend}/ocorrencias`).then(response => {
            this.ultimosDadosOcorrencias = response.data.ocorrencias;
            if (!this.state.jaCarregouOcorrencias || flag) {
                this.setState({
                    listaOcorrencias: response.data.ocorrencias,
                    jaCarregouOcorrencias: true
                });
            }
        }).catch(this.handleError).finally(() => this.setState({ isLoadingOcorrencias: false }));
    }

    criaAtendimento(semSolicitante) {
        let _idSolicitante;

        if (this.state.infosSolicitante.length === 0 || semSolicitante) _idSolicitante = undefined;
        else _idSolicitante = this.state.infosSolicitante.idUsuario;

        const _bodyAtendimento = {
            "idUsuarioSolicitante": _idSolicitante,
            "idPrioridadeAtendimento": 2,
            "descricao": (this.state.descricaoAtendimento && (this.state.descricaoAtendimento.trim() !== '')) ? this.state.descricaoAtendimento : undefined
        };
        this.setState({ isLoadingCriacao: true })

        axios.post(this.configurations.apiBasePath + `/atendimentos`, _bodyAtendimento).then(response => {

            this.props.history.replace(`/atendimentos/detalhes/${response.data.idAtendimento}`)
            this.setState({ atendimentoCriado: true });
            this.carregaInfosAtendimento(response.data.idAtendimento);
            this.atualizaContextAtendimentos();

        }).catch(this.handleError).finally(() => this.setState({ isLoadingCriacao: false, novoAtendimento: false }));
    }

    atualizaContextAtendimentos() {
        const arrayPermissoes = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const _flagAtendimento = arrayPermissoes.some(item => item === 1 || item === 2 || item === 4)
        if (_flagAtendimento) {
            axios.get(this.configurations.apiBasePath + `/atendimentos/abertos?listaStatusAtendimento=2,3`).then(response => {
                this.setAtendimentosMenu(response.data.atendimentos, this.state.infosAtendimento.idAtendimento)
            }).catch(this.handleError);
        }
    }

    toggleCadastroSolicitante() {
        this.setState({ exibeCadastroSolicitante: !this.state.exibeCadastroSolicitante })
    }

    handleOnChange(e) {
        e.preventDefault();
        this.setState({
            [e.target.name]: e.target.value, shouldBlockNavigation: true,
        })
        this.pendencias[e.target.name].pendente = true;
        this.pendencias[e.target.name].btnClick = false;
    }

    atualizaAtendimento(valor, parametro) {
        this.setState({ mudancaStatusAtendimento: true })
        let _campo, _loading, _finalizar = valor === 4;
        switch (parametro.toLowerCase()) {
            case "status":
                _campo = "idStatusAtendimento";
                _loading = "isLoadingStatusAtendimento";
                break;
            case "prioridade":
                _campo = "idPrioridadeAtendimento";
                _loading = "isLoadingPrioridadeAtendimento";
                break;
            case "descricao":
                _campo = "descricaoAtendimento";
                _loading = "isLoadingDescricaoAtendimento";
                break;
            default:
                _campo = "idStatusAtendimento";
                _loading = "isLoadingStatusAtendimento";
                break;
        }

        if (_finalizar && this.verificaPendencias()) {
            this.toggleModalAlteracoes();
        } else {
            if (_finalizar) _loading = "isLoadingFinalizar";
            this.setState({ [_loading]: true, isLoadingGeral: this.state.isLoadingGeral + 1, lastLocation: null })
            const _bodyAtendimento = { [_campo]: valor }

            axios.put(this.configurations.apiBasePath + `/atendimentos/${this.state.infosAtendimento.idAtendimento}`, _bodyAtendimento).then(response => {
                this.carregaInfosAtendimento(this.state.infosAtendimento.idAtendimento, _finalizar)
                if (_campo === "descricaoAtendimento") {
                    this.pendencias.descricaoAtendimento.pendente = false;
                    this.pendencias.descricaoAtendimento.btnClick = true;
                }
                this.atualizaContextAtendimentos();
            }).catch(this.handleError).finally(() => {
                this.setState({ [_loading]: false, isLoadingGeral: this.state.isLoadingGeral - 1, mudancaStatusAtendimento: false })
            });
        }
    }

    finalizarAtendimento() {
        this.setState({ modalAlteracoes: false })
        const _loading = "isLoadingFinalizar";
        this.setState({ [_loading]: true, isLoadingGeral: this.state.isLoadingGeral + 1, lastLocation: null })
        const _bodyAtendimento = { idStatusAtendimento: 4 }

        axios.put(this.configurations.apiBasePath + `/atendimentos/${this.state.infosAtendimento.idAtendimento}`, _bodyAtendimento).then(response => {
            this.carregaInfosAtendimento(this.state.infosAtendimento.idAtendimento);
            this.atualizaContextAtendimentos();
        }).catch(this.handleError).finally(() => {
            this.setState({ [_loading]: false, isLoadingGeral: this.state.isLoadingGeral - 1 })
        });
    }

    handleSelectChange(newValue, actionMeta) {
        this.setState({ idPrioridadeAtendimento: newValue.value }, () => this.atualizaAtendimento(this.state.idPrioridadeAtendimento, "prioridade"))
    };

    toggleModalTelefone(index, e) {
        if (e) e.preventDefault();
        this.setState({ modalRemoverTelefone: !this.state.modalRemoverTelefone }, () => {
            if (this.state.modalRemoverTelefone) this.setState({ indexTel: index })
        })
    }

    handleOnChangeTelefones(e, index, campo) {
        let _valorCampo = '';
        switch (campo.toLowerCase()) {
            case "numero":
                _valorCampo = e.target.value;
                break;
            case "codpais":
                _valorCampo = e.value;
                break;
            case "idtipotelefone":
                _valorCampo = e.value;
                break;

            default:
                break;
        }

        this.setState({
            telefonesSolicitante: update(this.state.telefonesSolicitante, { [index]: { [campo]: { $set: _valorCampo } } }),
            modalRemoverTelefone: false
        })

        this.pendencias.telefonesSolicitante.pendente = true;
        this.pendencias.telefonesSolicitante.btnClick = false;
    }

    removerTelefone() {
        let _novoArrayTelefones = this.state.telefonesSolicitante;
        _novoArrayTelefones[this.state.indexTel].remover = true;
        this.setState({ telefonesSolicitante: _novoArrayTelefones, modalRemoverTelefone: false })
        this.pendencias.telefonesSolicitante.pendente = true;
    }

    novoTelefone() {
        let _novoArrayTelefones = this.state.telefonesSolicitante;
        _novoArrayTelefones.push({
            codPais: "55",
            idTipoTelefone: 2,
            numero: undefined,
            tipo: 'Celular'
        })
        this.setState({ telefonesSolicitante: _novoArrayTelefones })
        this.pendencias.telefonesSolicitante.pendente = true;
    }

    atualizarDadosCadastrais() {
        const _idAtendimento = this.state.infosAtendimento.idAtendimento;
        if (this.pendencias.emailSolicitante.pendente) {
            this.setState({ isLoadingAtualizacaoCadastral: this.state.isLoadingAtualizacaoCadastral + 1, isLoadingEmail: true }, () => {
                axios.put(this.configurations.apiBasePath + `/membros/${this.state.infosAtendimento.codMembro}/detalhes`,
                    { idAtendimento: _idAtendimento, email: this.state.emailSolicitante }
                ).then(response => {
                    this.ultimosDadosCadastrais.email = this.state.emailSolicitante;
                    this.pendencias.emailSolicitante.pendente = false;
                    this.pendencias.emailSolicitante.btnClick = true;
                    this.carregaHistoricoAtendimento(_idAtendimento);
                    this.atualizaContextAtendimentos();
                }).catch(this.handleError).finally(() => {
                    this.setState({ isLoadingAtualizacaoCadastral: this.state.isLoadingAtualizacaoCadastral - 1, isLoadingEmail: false })
                });
            })
        } else this.pendencias.emailSolicitante.pendente = false;


        if (this.pendencias.telefonesSolicitante.pendente) {
            let _novoArrayTelefones = this.state.telefonesSolicitante;
            this.setState({ isLoadingAtualizacaoCadastral: this.state.isLoadingAtualizacaoCadastral + 1, isLoadingTelefone: true }, () => {
                axios.put(this.configurations.apiBasePath + `/telefones/${this.state.infosAtendimento.idSolicitante}`,
                    { idAtendimento: this.state.infosAtendimento.idAtendimento, telefones: _novoArrayTelefones }
                ).then(response => {
                    this.ultimosDadosCadastrais.telefones = _novoArrayTelefones;
                    this.pendencias.telefonesSolicitante.pendente = false;
                    this.pendencias.telefonesSolicitante.btnClick = true;
                    this.carregaHistoricoAtendimento(_idAtendimento);
                    this.atualizaContextAtendimentos();
                    this.atualizaTelefones();
                }).catch(this.handleError).finally(() => {
                    this.setState({ isLoadingAtualizacaoCadastral: this.state.isLoadingAtualizacaoCadastral - 1, isLoadingTelefone: false })
                });
            })
        } else this.pendencias.telefonesSolicitante.pendente = false;
    }

    atualizaTelefones() {
        axios.get(this.configurations.apiBasePath + `/telefones/${this.state.infosAtendimento.idSolicitante}`)
            .then(response => {
                this.setState({ telefonesSolicitante: response.data.telefones })
                // console.log(response)
            }).catch(this.handleError).finally(() => {
                this.setState({ isLoadingTelefone: false })
            });
    }

    maskPhone(tel) {
        const telBrasil = parseInt(tel.codPais, 10) === 55,
            tipoCel = parseInt(tel.idTipoTelefone, 10) === 2,
            cel = { mask: "(99) 99999-9999", placeholder: "(__) _____-____" },
            fixo = { mask: "(99) 9999-9999", placeholder: "(__) ____-____" };

        return {
            mask: telBrasil ? (tipoCel ? cel.mask : fixo.mask) : '',
            placeholder: telBrasil ? (tipoCel ? cel.placeholder : fixo.placeholder) : '',
        }
    }

    btnStatusAtendimento() {
        let _color, _label, _icon, _novoIdStatus;
        switch (this.state.infosAtendimento.idStatusAtendimento) {
            case 2:
                _color = 'info';
                _label = 'retomar atendimento';
                _icon = 'fas fa-play-circle'
                _novoIdStatus = 3;
                break;
            case 3:
                _color = 'warning';
                _label = 'pausar atendimento';
                _icon = 'fas fa-pause-circle'
                _novoIdStatus = 2;
                break;
            default:
                _color = 'warning';
                _label = 'pausar atendimento';
                _icon = 'fas fa-pause-circle'
                _novoIdStatus = 2;
                break;
        }
        return {
            label: _label, color: _color, icon: _icon, novoIdStatus: _novoIdStatus
        };
    }

    salvarOcorrencia(idOcorr, bodyOcorr) {
        const _index = this.state.listaOcorrencias.findIndex(item => item.idOcorrencia === idOcorr);

        this.setState({ listaOcorrencias: update(this.state.listaOcorrencias, { [_index]: { loading: { $set: true } } }) }, () => {
            axios.put(this.configurations.apiBasePath + `/atendimentos/ocorrencias/${idOcorr}`, bodyOcorr).then(response => {
                this.setState({
                    listaOcorrencias: update(this.state.listaOcorrencias, { [_index]: { btnClick: { $set: true }, pendente: { $set: false } } }),
                    algumaPendenciaOcorrencia: false
                }, () => {
                    this.pendencias.ocorrencias.pendente = false;
                });
                this.carregaOcorrenciasAtendimento(this.state.infosAtendimento.idAtendimento);
                this.atualizaContextAtendimentos();
            }).catch((err) => {
                this.handleError(err);
                this.setState({ listaOcorrencias: update(this.state.listaOcorrencias, { [_index]: { btnClick: { $set: false } } }) });
            }).finally(() => {
                this.setState({ listaOcorrencias: update(this.state.listaOcorrencias, { [_index]: { loading: { $set: false } } }) })
                this.carregaHistoricoAtendimento(this.state.infosAtendimento.idAtendimento);
            });
        })
    }

    excluirOcorrencia(idOcorr) {
        const _aux1 = this.state.listaOcorrencias.filter(item => item.pendente).filter(item => item.idOcorrencia !== idOcorr);
        const _pendenciaOutrasOcorr = _aux1.length > 0;
        const _podeExcluir = !_pendenciaOutrasOcorr;

        if (_podeExcluir) {
            const _index = this.state.listaOcorrencias.findIndex(item => item.idOcorrencia === idOcorr);
            const _idAtendimento = this.state.infosAtendimento.idAtendimento;
            this.setState({ isLoadingOcorrencias: true })
            axios.delete(this.configurations.apiBasePath + `/atendimentos/ocorrencias/${idOcorr}`).then(response => {
                this.setState({
                    listaOcorrencias: update(this.state.listaOcorrencias, { [_index]: { btnClick: { $set: true }, pendente: { $set: false } } }),
                    algumaPendenciaOcorrencia: false
                }, () => {
                    this.pendencias.ocorrencias.pendente = false;
                });
                this.carregaOcorrenciasAtendimento(_idAtendimento, true)
                this.carregaHistoricoAtendimento(_idAtendimento);
                this.atualizaContextAtendimentos();
            }).catch((err) => {
                this.handleError(err);
                this.setState({ listaOcorrencias: update(this.state.listaOcorrencias, { [_index]: { btnClick: { $set: false } } }) });
            }).finally(() => {
            });
        } else {
            this.toggleModalAvisoOcorrencia();
        }
    }

    novaOcorrencia() {
        const _aux1 = this.state.listaOcorrencias.filter(item => item.pendente);
        const _pendenciaOcorr = _aux1.length > 0;
        const _podeAdicionar = !_pendenciaOcorr;

        if (_podeAdicionar) {
            const _idAtendimento = this.state.infosAtendimento.idAtendimento;
            this.setState({ isLoadingNovaOcorrencia: true })
            axios.post(this.configurations.apiBasePath + `/atendimentos/${_idAtendimento}/ocorrencias`).then(response => {
                this.carregaOcorrenciasAtendimento(_idAtendimento, true)
                this.carregaHistoricoAtendimento(_idAtendimento);
            }).catch(this.handleError).finally(() => {
                this.setState({ isLoadingNovaOcorrencia: false, novoAtendimento: false })
            });
        } else {
            this.toggleModalAvisoOcorrencia();
        }
    }

    registraPendenciaOcorrencia(_index) {
        this.setState({ listaOcorrencias: update(this.state.listaOcorrencias, { [_index]: { pendente: { $set: true } } }) }, () => {
            this.pendencias.ocorrencias.pendente = true;
        })
    }

    toggleModalAvisoOcorrencia() {
        this.setState({ modalAvisoOcorrencia: !this.state.modalAvisoOcorrencia })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    toggleModalAlteracoes() {
        this.setState({ modalAlteracoes: !this.state.modalAlteracoes })
    }

    showModalAlteracoes(location) {
        this.setState({ modalAlteracoes: true, lastLocation: location })
    }

    closeModalAlteracoes(callback) {
        this.setState({ modalAlteracoes: false }, () => {
            if (callback) callback();
        })
    }

    handleBlockedNavigation(nextLocation) {
        const { confirmedNavigation } = this.state
        if (!confirmedNavigation) {
            this.showModalAlteracoes(nextLocation)
            return false
        }
        return true
    }

    handleConfirmNavigationClick() {
        this.closeModalAlteracoes(() => {
            // const { navigate } = this.props
            const { lastLocation } = this.state
            if (lastLocation) {
                this.setState({
                    confirmedNavigation: true
                }, () => {
                    // Navigate to the previous blocked location with your navigate function     
                    this.props.history.push(lastLocation.pathname)
                })
            }
        })
    }

    alteracoesNaoSalvas() {
        this.verificaPendencias(this.ultimosDadosAtendimento, { descricao: this.state.descricaoAtendimento });
        this.verificaPendencias(this.ultimosDadosCadastrais, { email: this.state.emailSolicitante, telefones: this.state.telefonesSolicitante });
        const _msgPend = this.state.mensagemPendencias;
        if (this.pendencias.ocorrencias.pendente) {
            _msgPend.push(this.pendencias.ocorrencias.mensagem);
            this.setState({ mensagemPendencias: this.state.mensagemPendencias })
        }
    }

    verificaPendencias() {
        let _mensagemPendencias = [];
        for (var key in this.pendencias) {
            if (this.pendencias[key].pendente) _mensagemPendencias.push(this.pendencias[key].mensagem)
        }
        if (JSON.stringify(this.state.mensagemPendencias) !== JSON.stringify(_mensagemPendencias)) {
            this.setState({ mensagemPendencias: _mensagemPendencias })
        }
        return _mensagemPendencias.length > 0
    }

    render() {
        const { organizacao, funcoes, nome, codMembro } = this.state.infosSolicitante;
        return (

            <Consumer>
                {({ greeting, setGreeting, listaAtendimentosMenu, setAtendimentosMenu, trueOrFalse }) => {
                    this.setAtendimentosMenu = setAtendimentosMenu;
                    return (
                        <>
                            <Prompt
                                // when={this.state.shouldBlockNavigation}
                                when={this.verificaPendencias() && this.state.infosAtendimento.idStatusAtendimento !== 4}
                                message={this.handleBlockedNavigation}
                            />
                            <div className={`row atendimento`}>
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-9">
                                            <h2 className="title-1">Detalhes do Atendimento</h2>
                                        </div>
                                        <div className="col-3 text-right">
                                            <button onClick={() => this.props.history.push({ pathname: '/atendimentos/lista' })} className="btn btn-outline-secondary">voltar</button>
                                        </div>
                                    </div>
                                </div>
                                <div className={`col-12 ${this.state.pedidoFinalizado ? 'desativa-interacao' : ''}`}>
                                    <div className="row">
                                        {!this.state.atendimentoCriado ? (
                                            <div className="col-12 py-3">
                                                <div className="card rounded">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <div className="row">
                                                                    <div className="col-12 py-2">
                                                                        {this.state.buscaHeader && (
                                                                            <form className="form-header" action="" method="POST">
                                                                                <label><strong>Solicitante do Atendimento:</strong></label>
                                                                                <AsyncTypeahead
                                                                                    id="mainSearch"
                                                                                    isLoading={this.state.isLoading}
                                                                                    className="ebs-typeahead w-100"
                                                                                    onChange={(s) => {
                                                                                        if (s && s.length > 0) {
                                                                                            this.carregaInfosSolicitante(s[0].codMembro);
                                                                                        }
                                                                                    }}
                                                                                    labelKey={(option) => {
                                                                                        if (option) {
                                                                                            switch (option.type) {
                                                                                                case 1:
                                                                                                    return `M${option.codMembro.toString()}`;
                                                                                                default:
                                                                                                    return option.nome;
                                                                                            }
                                                                                        } else {
                                                                                            return option;
                                                                                        }
                                                                                    }
                                                                                    }
                                                                                    renderMenuItemChildren={(option, props, idx) => (

                                                                                        <div className="d-flex align-items-center border-bottom">
                                                                                            <div className="mr-2"><UserPhoto src={`${this.configurations.apiBasePath}/minhas-informacoes/foto/${option.codMembro.toString()}`}></UserPhoto></div>
                                                                                            <Highlighter search={props.text}>
                                                                                                {option.nome}
                                                                                            </Highlighter>
                                                                                            &nbsp;<small>(
                                                                                            <Highlighter search={props.text.substr(1, props.text.length)}>
                                                                                                    {option.codMembro ? option.codMembro.toString() : ''}
                                                                                                </Highlighter>)</small>
                                                                                            &nbsp;<span className="badge badge-info">{option.divisao}</span>
                                                                                            &nbsp; - {option.coordenadoria}
                                                                                        </div>
                                                                                    )}
                                                                                    delay={400}
                                                                                    emptyLabel="Nenhum resultado encontrado"
                                                                                    searchText="Procurando..."
                                                                                    promptText="Digite para procurar..."
                                                                                    minLength={2}
                                                                                    placeholder="Insira o nome ou código de membro..."
                                                                                    onSearch={query => {
                                                                                        this.setState({ isLoading: true });
                                                                                        axios.get(this.configurations.apiBasePath + `/busca?query=${query}`)
                                                                                            .then(resp => {
                                                                                                if (resp.data && (resp.data.orders || resp.data.users)) {
                                                                                                    this.setState({
                                                                                                        isLoading: false,
                                                                                                        options: resp.data.orders.length > 0 ? resp.data.orders : resp.data.users
                                                                                                    });
                                                                                                }
                                                                                            });
                                                                                    }}
                                                                                    options={this.state.options}
                                                                                />
                                                                            </form>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-12 py-2">
                                                                        {this.state.isLoadingSolicitante ? (
                                                                            <div className="row no-gutters">
                                                                                <div className="col-12 text-center">
                                                                                    {this.state.flagBuscaSolicitante && (
                                                                                        <div className="spinner-border text-primary" role="status" />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                                <div className="row no-gutters">
                                                                                    <div className="col-12 px-3">
                                                                                        <div className="row no-gutters align-items-center">
                                                                                            <div className="col-1 px-3">
                                                                                                <div className="profile-photo" style={{ "backgroundImage": `url(${this.configurations.apiBasePath}/minhas-informacoes/foto/${codMembro})` }} />
                                                                                            </div>
                                                                                            <div className="col-11">
                                                                                                <h6 className="my-0">{nome} ({codMembro})</h6>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="offset-1 col-11 px-3">
                                                                                        <div className="row">
                                                                                            <div className="col-3 py-1">
                                                                                                <small><strong>Coord. Geral:</strong> {organizacao.coordGeral}</small>
                                                                                            </div>
                                                                                            <div className="col-3 py-1">
                                                                                                <small><strong>Coord:</strong> {organizacao.coordenadoria}</small>
                                                                                            </div>
                                                                                            <div className="col-3 py-1">
                                                                                                <small><strong>Sub:</strong> {organizacao.sub}</small>
                                                                                            </div>
                                                                                            <div className="col-3 py-1">
                                                                                                <small><strong>RM/RE:</strong> {organizacao.rm}</small>
                                                                                            </div>
                                                                                            {organizacao.area && (
                                                                                                <div className="col-3 py-1">
                                                                                                    <small><strong>Área:</strong> {organizacao.area}</small>
                                                                                                </div>
                                                                                            )}
                                                                                            {organizacao.regional && (
                                                                                                <div className="col-3 py-1">
                                                                                                    <small><strong>Regional:</strong> {organizacao.regional}</small>
                                                                                                </div>
                                                                                            )}
                                                                                            <div className="col-3  py-1">
                                                                                                <small><strong>Distrito:</strong> {organizacao.distrito}</small>
                                                                                            </div>
                                                                                            <div className="col-3  py-1">
                                                                                                <small><strong>Comunidade:</strong> {organizacao.comunidade}</small>
                                                                                            </div>
                                                                                            <div className="col-3  py-1">
                                                                                                <small><strong>Bloco:</strong> {organizacao.bloco}</small>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                    {this.state.isLoadingCriacao ? (
                                                                        <div className={`col-12 py-2 text-center`}>
                                                                            <div className="spinner-border text-primary" role="status" />
                                                                        </div>
                                                                    ) : (
                                                                            <div className={`col-12 py-2 text-right`}>
                                                                                <button type="button" onClick={() => this.criaAtendimento(true)} className="btn btn-outline-secondary mr-2">não possui cód. membro</button>
                                                                                <button onClick={() => this.criaAtendimento(false)} disabled={this.state.infosSolicitante.length <= 0} type="button" className="btn btn-outline-info">cadastrar solicitante</button>
                                                                            </div>
                                                                        )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                                <>
                                                    {(this.state.jaCarregouInfosSolicitante || this.state.atendimentoSemSolicitante) ? (
                                                        <div className="col-12 py-2">
                                                            <div className="row">
                                                                <div className="col-12 py-2">
                                                                    <div className="card rounded py-2 px-3">
                                                                        <div className="row align-items-center">
                                                                            <div className="col-3 text-left">
                                                                                <strong>Núm. Atendimento: </strong> {this.state.infosAtendimento.idAtendimento}
                                                                            </div>
                                                                            <div className="col-9 text-center">
                                                                                <div className="row align-items-center">
                                                                                    <div className="col-4 text-center">
                                                                                        <span className={`badge badge-status-atendimento badge-${this.tipoBadgeAtendimento(this.state.infosAtendimento.idStatusAtendimento)}`}>{this.state.infosAtendimento.nomeStatusAtendimento}</span>
                                                                                    </div>
                                                                                    <div className="col-4 text-center">
                                                                                        <div className="form-inline">
                                                                                            <label className="mr-2" htmlFor="ddlPrioridades"><strong>Prioridade:</strong></label>
                                                                                            {this.state.isLoadingPrioridadeAtendimento ? (
                                                                                                <div className={`spinner-border spinner-border-sm text-primary`} role="status" />
                                                                                            ) : (
                                                                                                    <Select
                                                                                                        id="ddlPrioridades"
                                                                                                        closeMenuOnSelect={true}
                                                                                                        components={makeAnimated()}
                                                                                                        value={this.prioridadesOptions.filter(item => item.value === this.state.infosAtendimento.idPrioridadeAtendimento)}
                                                                                                        name="listaPrioridades"
                                                                                                        onChange={this.handleSelectChange}
                                                                                                        options={this.prioridadesOptions}
                                                                                                        className="w-50"
                                                                                                        isDisabled={this.state.isLoadingGeral > 0 || this.state.pedidoFinalizado}
                                                                                                    />
                                                                                                )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-4 py-1 text-right">
                                                                                        <div className="d-flex align-items-center justify-content-end">
                                                                                            <strong>Resp: </strong> <span className="mx-2">{this.state.infosAtendimento.nomeUserFukyo}</span>
                                                                                            <UserPhoto src={`${this.state.infosAtendimento.fotoUserFukyo}`}></UserPhoto>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {this.state.infosAtendimento.idStatusAtendimento !== 4 && (
                                                                    <div className="col-12 py-3">
                                                                        <div className="row">
                                                                            <div className="col-6 py-3 text-right">
                                                                                <button disabled={this.state.isLoadingGeral > 0} onClick={() => this.atualizaAtendimento(this.btnStatusAtendimento().novoIdStatus, "status")} className={`btn btn-status-atendimento btn-outline-${this.btnStatusAtendimento().color}`}>
                                                                                    {this.state.isLoadingStatusAtendimento ? (
                                                                                        <div className={`spinner-border spinner-border-sm text-${this.btnStatusAtendimento().color}`} role="status" />
                                                                                    ) : (
                                                                                            <><i className={this.btnStatusAtendimento().icon + ` mr-3 icon-status-atendimento`}></i>{this.btnStatusAtendimento().label}</>
                                                                                        )}
                                                                                </button>
                                                                            </div>
                                                                            <div className="col-6 py-3 text-left">
                                                                                <button disabled={this.state.isLoadingGeral > 0} onClick={() => this.atualizaAtendimento(4, "status")} className={`btn btn-status-atendimento btn-outline-success`}>
                                                                                    {this.state.isLoadingFinalizar ? (
                                                                                        <div className="spinner-border spinner-border-sm text-success" role="status" />
                                                                                    ) : (
                                                                                            <><i className="fas fa-check-circle mr-3 icon-status-atendimento"></i>finalizar atendimento</>
                                                                                        )}

                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {(this.state.isLoadingAtendimento || (this.state.isLoadingGeral > 0)) && (
                                                                    <div className="col-12 text-center py-5">
                                                                        <div className="spinner-border text-primary" role="status" />
                                                                    </div>
                                                                )}
                                                                <div className={`col-12 py-2 ${this.state.isLoadingGeral > 0 ? 'd-none' : ''}`}>
                                                                    <div className="card rounded">
                                                                        <div className="card-body">
                                                                            {this.state.atendimentoSemSolicitante ? (
                                                                                <div className="row">
                                                                                    <div className="col-12 text-center">
                                                                                        <h4>Atendimento sem código de membro cadastrado</h4>
                                                                                    </div>
                                                                                </div>
                                                                            ) : (
                                                                                    <div className="row align-items-center">
                                                                                        <div className="col-12">
                                                                                            <div className="row no-gutters align-items-center">
                                                                                                <div className="col-1 px-3">
                                                                                                    <div className="profile-photo" style={{ "backgroundImage": `url(${this.configurations.apiBasePath}/minhas-informacoes/foto/${this.state.infosAtendimento.codMembro})` }} />
                                                                                                </div>
                                                                                                <div className="col-11 px-3">
                                                                                                    <h4 className="my-0">{this.state.infosAtendimento.nomeMembro} ({this.state.infosAtendimento.codMembro})</h4>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-6 py-3">
                                                                                            {this.state.isLoadingSolicitante ? (
                                                                                                <div className="row">
                                                                                                    <div className="col-12 py-3 text-center">
                                                                                                        <div className="spinner-border text-primary" role="status" />
                                                                                                    </div>
                                                                                                </div>
                                                                                            ) : (
                                                                                                    <div className="row no-gutters">
                                                                                                        <div className="col-12 py-3">
                                                                                                            <strong>{funcoes.length > 1 ? 'Funções:' : 'Função:'}</strong> {funcoes.length === 0 ? 'Membro' :
                                                                                                                funcoes.map((item, index) =>
                                                                                                                    <span key={`funcao-${index}`}>{item} {index === funcoes.length - 1 ? '' : ' / '}</span>
                                                                                                                )
                                                                                                            }
                                                                                                        </div>
                                                                                                        <div className="col-6 py-3">
                                                                                                            <strong>Coord. Geral:</strong> {organizacao.coordGeral}
                                                                                                        </div>
                                                                                                        <div className="col-6 py-3">
                                                                                                            <strong>Coordenadoria:</strong> {organizacao.coordenadoria}
                                                                                                        </div>
                                                                                                        <div className="col-6 py-3">
                                                                                                            <strong>Sub. Coord:</strong> {organizacao.sub}
                                                                                                        </div>
                                                                                                        <div className="col-6 py-3">
                                                                                                            <strong>RM/RE:</strong> {organizacao.rm}
                                                                                                        </div>
                                                                                                        {organizacao.area && (
                                                                                                            <div className="col-6 py-3">
                                                                                                                <strong>Área:</strong> {organizacao.area}
                                                                                                            </div>
                                                                                                        )}

                                                                                                        {organizacao.regional && (
                                                                                                            <div className="col-6 py-3">
                                                                                                                <strong>Regional:</strong> {organizacao.regional}
                                                                                                            </div>
                                                                                                        )}
                                                                                                        <div className="col-6 py-3">
                                                                                                            <strong>Distrito:</strong> {organizacao.distrito}
                                                                                                        </div>
                                                                                                        <div className="col-6 py-3">
                                                                                                            <strong>Comunidade:</strong> {organizacao.comunidade}
                                                                                                        </div>
                                                                                                        <div className="col-6 py-3">
                                                                                                            <strong>Bloco:</strong> {organizacao.bloco}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )}
                                                                                        </div>
                                                                                        <div className="col-6 py-3">
                                                                                            <div className="row no-gutters">
                                                                                                <div className="col-12 card rounded px-3 py-4">
                                                                                                    <div className="row no-gutters">
                                                                                                        <div className="col-12">
                                                                                                            <form className="form-inline" action="/action_page.php">
                                                                                                                <div className="form-group w-100 py-2">
                                                                                                                    <label className="mr-3" htmlFor="email"><strong>Email:</strong></label>
                                                                                                                    <input type="email" className="form-control w-75" id="email" name="emailSolicitante" value={this.state.emailSolicitante} onChange={this.handleOnChange} disabled={this.state.pedidoFinalizado}
                                                                                                                    />
                                                                                                                </div>

                                                                                                                {this.state.telefonesSolicitante.map((tel, index) => {
                                                                                                                    if (!tel.remover) return (
                                                                                                                        <div key={`tel-${index}`} className="form-group w-100 py-2">
                                                                                                                            <Select
                                                                                                                                id={`ddlPais-${index}`}
                                                                                                                                placeholder="País..."
                                                                                                                                closeMenuOnSelect={true}
                                                                                                                                components={makeAnimated()}
                                                                                                                                defaultValue={this.paisesOptions.filter(item => item.value === tel.codPais)}
                                                                                                                                name="codPais"
                                                                                                                                onChange={e => this.handleOnChangeTelefones(e, index, "codPais")}
                                                                                                                                options={this.paisesOptions}
                                                                                                                                className="w-25 mr-1"
                                                                                                                                isDisabled={this.state.pedidoFinalizado}
                                                                                                                            />
                                                                                                                            <Select
                                                                                                                                id={`ddlTipoTelefone-${index}`}
                                                                                                                                placeholder="Tipo..."
                                                                                                                                closeMenuOnSelect={true}
                                                                                                                                components={makeAnimated()}
                                                                                                                                defaultValue={this.tipoTelefoneOptions.filter(item => item.value === tel.idTipoTelefone)}
                                                                                                                                name="idTipoTelefone"
                                                                                                                                onChange={e => this.handleOnChangeTelefones(e, index, "idTipoTelefone")}
                                                                                                                                options={this.tipoTelefoneOptions}
                                                                                                                                className="w-25 mr-1"
                                                                                                                                isDisabled={this.state.pedidoFinalizado}
                                                                                                                            />
                                                                                                                            <InputMask
                                                                                                                                autoComplete="off"
                                                                                                                                name="numero"
                                                                                                                                type="tel"
                                                                                                                                className="form-control"
                                                                                                                                maskChar="_"
                                                                                                                                id={index}
                                                                                                                                mask={this.maskPhone(tel).mask}
                                                                                                                                placeholder={this.maskPhone(tel).placeholder}
                                                                                                                                value={tel.numero}
                                                                                                                                onChange={e => this.handleOnChangeTelefones(e, index, "numero")}
                                                                                                                                disabled={this.state.pedidoFinalizado}
                                                                                                                            />
                                                                                                                            <i disabled={this.state.modalRemoverTelefone || this.state.pedidoFinalizado} onClick={(e) => this.toggleModalTelefone(index, e)} className={`ml-2 fas fa-trash-alt text-danger cursor-pointer ${this.state.pedidoFinalizado ? 'd-none' : ''}`}></i>
                                                                                                                        </div>
                                                                                                                    )
                                                                                                                    else return false;
                                                                                                                })}
                                                                                                            </form>
                                                                                                            <button disabled={this.state.pedidoFinalizado} onClick={this.novoTelefone} className={`btn btn-sm btn-outline-primary btn-icon ${this.state.pedidoFinalizado ? 'd-none' : ''}`}><i className={`fas fa-phone-alt icon-btn-outline-primary mr-1`}></i> novo telefone</button>
                                                                                                        </div>
                                                                                                        <div className="col-12 text-right pt-3">
                                                                                                            {this.state.isLoadingTelefone || this.state.isLoadingEmail ? (
                                                                                                                <div className={`spinner-border text-primary`} role="status" />
                                                                                                            ) : (<>
                                                                                                                {
                                                                                                                    (this.pendencias.emailSolicitante.btnClick || this.pendencias.telefonesSolicitante.btnClick)
                                                                                                                    && (!this.pendencias.emailSolicitante.pendente && !this.pendencias.telefonesSolicitante.pendente) && (
                                                                                                                        <span className="my-0 mr-4 text-success alerta-alteracoes">Alterações salvas com sucesso!</span>
                                                                                                                    )}
                                                                                                                {(this.pendencias.emailSolicitante.pendente || this.pendencias.telefonesSolicitante.pendente) && (
                                                                                                                    <span className="my-0 mr-4 text-danger alerta-alteracoes">As alterações {this.state.pedidoFinalizado ? '' : 'ainda'} não foram salvas.</span>
                                                                                                                )}
                                                                                                                <button disabled={this.state.pedidoFinalizado} onClick={this.atualizarDadosCadastrais} className={`btn btn-outline-success btn-icon ${this.state.pedidoFinalizado ? 'd-none' : ''}`}>
                                                                                                                    <i className={`fas fa-user-alt icon-btn-outline-success mr-1`}></i> salvar alterações
                                                                                            </button>
                                                                                                            </>)}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                            <div className="col-12 text-center py-5">
                                                                <div className="spinner-border text-primary" role="status" />
                                                            </div>
                                                        )}
                                                </>
                                            )}
                                    </div>
                                </div>
                                <div className={`col-12 py-2 ${(this.state.atendimentoCriado && this.state.isLoadingAtendimento) || (this.state.isLoadingGeral > 0) ? 'd-none' : ''}`}>
                                    <div className="card rounded">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-12">
                                                    <label><strong>Descrição do Atendimento:</strong></label>
                                                </div>
                                                <div className="col-12">
                                                    <textarea name="descricaoAtendimento" rows="5" className="w-100 form-control" onChange={this.handleOnChange} value={this.state.descricaoAtendimento ? this.state.descricaoAtendimento : ''} disabled={this.state.pedidoFinalizado} />
                                                </div>
                                                <div className="col-12 text-right pt-3">
                                                    {
                                                        (this.pendencias.descricaoAtendimento.btnClick && !this.pendencias.descricaoAtendimento.pendente) && (
                                                            <span className="my-0 mr-4 text-success alerta-alteracoes">Alterações salvas com sucesso!</span>
                                                        )}
                                                    {this.pendencias.descricaoAtendimento.pendente && (
                                                        <span className="my-0 mr-4 text-danger alerta-alteracoes">As alterações {this.state.pedidoFinalizado ? '' : 'ainda'} não foram salvas.</span>
                                                    )}
                                                    <button onClick={() => this.atualizaAtendimento(this.state.descricaoAtendimento, "descricao")} disabled={!this.state.atendimentoCriado || this.state.pedidoFinalizado} className={`btn btn-outline-success btn-icon ${this.state.pedidoFinalizado ? 'd-none' : ''}`}><i className={`fas fa-file-alt mr-1 icon-btn-outline-success`}></i> salvar descrição</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.isLoadingOcorrencias ? (
                                    <div className={`col-12 py-2 text-center ${this.state.atendimentoCriado ? '' : 'd-none'}`}>
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                ) : (
                                        <div className={`col-12 py-4 
                    ${(this.state.isLoadingAtendimento || (this.state.isLoadingGeral > 0)) ? 'd-none' : ''}`}>
                                            <div className="row no-gutters">
                                                {this.state.isLoadingNovaOcorrencia ? (
                                                    <div className="col-12 py-2 text-center">
                                                        <div className="spinner-border text-primary" role="status" />
                                                    </div>
                                                ) : (
                                                        <div className="col-12 py-2 text-center">
                                                            <button disabled={this.state.pedidoFinalizado} onClick={this.novaOcorrencia} className={`btn btn-outline-info btn-icon ${this.state.pedidoFinalizado ? 'd-none' : ''}`}><i className="fas fa-plus mr-1 icon-btn-outline-info"></i> nova ocorrência</button>
                                                        </div>
                                                    )}
                                                {this.state.listaOcorrencias.length > 0 && (
                                                    <>
                                                        <div className="col-12 py-2 text-center">
                                                            <strong>Lista de Ocorrências</strong>
                                                        </div>
                                                        <div className="col-12">
                                                            {this.state.listaOcorrencias.map((item, index) => {
                                                                return (
                                                                    <div key={`ocorr-${index}`} className="row no-gutters">
                                                                        <div className="col-12 py-2">
                                                                            <CardOcorrencia
                                                                                key={index}
                                                                                index={index + 1}
                                                                                ocorrencia={item}
                                                                                categorias={this.state.categoriasOptions}
                                                                                salvarOcorrencia={this.salvarOcorrencia}
                                                                                excluirOcorrencia={this.excluirOcorrencia}
                                                                                listaCategorias={item.listaCategorias.map(cat => ({ label: cat.nomeCategoria, value: cat.idCategoria }))}
                                                                                loading={this.state.isLoadingOcorrencias}
                                                                                loadingOcorrencia={item.loading}
                                                                                pedidoFinalizado={this.state.pedidoFinalizado}
                                                                                pendente={item.pendente}
                                                                                btnClick={item.btnClick}
                                                                                registraPendencia={this.registraPendenciaOcorrencia}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                {/* HISTÓRICO DO ATENDIMENTO */}
                                {!this.state.isLoadingAtendimento && !this.state.isLoadingHistorico && (this.state.isLoadingGeral <= 0) && (
                                    <div className="col-12">
                                        <div className="row no-gutters">
                                            <div className="col-12 py-2 text-center">
                                                <strong>Histórico do Atendimento</strong>
                                            </div>
                                            <div className="col-12">
                                                <HistoricoAtendimento historico={this.state.historicoAtendimento} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <ErrorModal
                                    isOpen={this.state.hasError}
                                    message={this.state.errorMessage}
                                    closeErrorModal={this.closeErrorModal}
                                    goBack={false}
                                />
                                <ModalAlteracoes
                                    isOpen={this.state.modalAlteracoes}
                                    callBackDescartar={this.state.mudancaStatusAtendimento ? this.finalizarAtendimento : this.handleConfirmNavigationClick}
                                    toggle={this.closeModalAlteracoes}
                                    exibeLista={this.state.mensagemPendencias.length > 0}
                                    listaPendencias={this.state.mensagemPendencias}

                                />
                                <Modal isOpen={this.state.modalRemoverTelefone} toggle={this.toggleModalTelefone}>
                                    <ModalHeader toggle={this.toggleModalTelefone}>Exclusão de Telefone</ModalHeader>
                                    <ModalBody>
                                        <p className="m-0">Deseja confirmar a exclusão de telefone? Essa ação não poderá ser revertida.</p>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button onClick={this.removerTelefone} color="danger">excluir</Button>
                                        {` `}
                                        <Button onClick={this.toggleModalTelefone} color="secondary">voltar</Button>
                                    </ModalFooter>
                                </Modal>

                                <Modal isOpen={this.state.modalAvisoOcorrencia} toggle={this.toggleModalAvisoOcorrencia}>
                                    <ModalHeader toggle={this.toggleModalAvisoOcorrencia}>Alterações em ocorrências</ModalHeader>
                                    <ModalBody>
                                        <p className="m-0">Antes de prosseguir, é necessário salvar as alterações pendentes nas ocorrências existentes.</p>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button onClick={this.toggleModalAvisoOcorrencia} color="secondary">ok</Button>
                                    </ModalFooter>
                                </Modal>
                            </div>
                        </>
                    )
                }}
            </Consumer>
        )
    }
}

export default NovoAtendimento;